module.exports = __webpack_public_path__ + "static/media/searchIcon.72ea0cec.svg";